export default {
  API_URL: 'https://workshop.explor.games/api',
  GOOGLE_API_KEY: 'AIzaSyDrzBnG06FzM-F5Oo5tyTSUhv_a7PRlVYk',
  MAPBOX_TOKEN: 'pk.eyJ1IjoiZGV2LWF0ZWxpZXJuYXR1cmUiLCJhIjoiY21hMHZvdTYzMmNobDJqc21yemVtam45ZiJ9.V2vf3mPpnOSCOfhHD0nzcw',
}
